import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Ajout automatique du cookie CSRF pour les requêtes authentifiées
api.interceptors.request.use((config) => {
  const csrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('csrftoken='))
    ?.split('=')[1];
  if (csrfToken) {
    config.headers['X-CSRFToken'] = csrfToken;
  }
  return config;
});

// Session admin expirée : retour à l'écran de connexion
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    if ((status === 401 || status === 403) && url.startsWith('/admin/') && url !== '/admin/login/') {
      if (window.location.pathname.startsWith('/recruteur') && window.location.pathname !== '/recruteur/login') {
        window.location.assign('/recruteur/login');
      }
    }
    return Promise.reject(error);
  },
);

const query = (params = {}) => {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== '' && v != null));
  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
};

// === API Publique ===

export const submitCandidature = async (formData) => {
  const response = await api.post('/candidatures/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getCampagne = async () => {
  const response = await api.get('/campagne/');
  return response.data;
};

// === API Admin ===

export const getCampagneAdmin = async () => {
  const response = await api.get('/admin/campagne/');
  return response.data;
};

export const updateCampagne = async (data) => {
  const response = await api.put('/admin/campagne/', data);
  return response.data;
};

export const updateLiensPartage = async (liensValiditeJours) => {
  const response = await api.patch('/admin/campagne/', { liens_validite_jours: liensValiditeJours });
  return response.data;
};

export const revoquerLiensPartage = async () => {
  const response = await api.post('/admin/campagne/revoquer-liens/');
  return response.data;
};

export const login = async (username, password) => {
  const response = await api.post('/admin/login/', { username, password });
  return response.data;
};

export const logout = () => api.post('/admin/logout/');

export const getSession = async () => {
  const response = await api.get('/admin/me/');
  return response.data;
};

export const getCandidatures = async (params = {}) => {
  const response = await api.get('/admin/candidatures/', { params });
  return response.data;
};

export const getCandidatureDetail = async (id) => {
  const response = await api.get(`/admin/candidatures/${id}/`);
  return response.data;
};

export const updateCandidatureStatut = async (id, data) => {
  const response = await api.patch(`/admin/candidatures/${id}/statut/`, data);
  return response.data;
};

export const bulkUpdateStatut = async (ids, statut) => {
  const response = await api.post('/admin/candidatures/bulk-statut/', { ids, statut });
  return response.data;
};

export const getDashboardStats = async () => {
  const response = await api.get('/admin/dashboard/stats/');
  return response.data;
};

// === Téléchargements (session admin transmise par cookie) ===

export const exportUrl = (params) => `${API_BASE}/admin/candidatures/export/${query(params)}`;

export const exportXlsxUrl = (params) => `${API_BASE}/admin/candidatures/export-xlsx/${query(params)}`;

export const documentsLotUrl = (params) => `${API_BASE}/admin/candidatures/documents/${query(params)}`;

export const documentsCandidatUrl = (id) => `${API_BASE}/admin/candidatures/${id}/documents/`;

export const documentUrl = (id, champ, inline = false) =>
  `${API_BASE}/admin/candidatures/${id}/documents/${champ}/${inline ? '?inline=1' : ''}`;

export default api;
